export enum AppConfigKeys {
    USER_REGION = 'userRegion',
    PRIVACY_POLICY_URL = 'privacyPolicyUrl',
    CONTACT_PHONE = 'contactPhone',
    PRIMARY_WELCOME_LINK = 'primaryWelcomeLink',
    SECONDARY_WELCOME_LINK = 'secondaryWelcomeLink',
}
